import { GenericDateTime } from './GenericDateTime';

if (typeof window !== 'undefined') {
  window.GenericDateTime = GenericDateTime;
}

export { GenericDateTime };

